<div
  class="product-single"
  [ngClass]="{
    badges: hasBadge,
    normal: !wide,
    wide: wide,
    'is-recommend': isRecommendProduct,
    bestSeller: bestSeller,
    'new-item': product?.bestSellerProductSetting?.badges?.[0]?.badgeType === BADGE_TYPE.NEW,
  }"
>
  <a>
    @if (hasBadge) {
      <div class="flag">
        @for (badge of product | badges: 'flag' : excludeBadges; track badge) {
          <em [class]="badge.badgeType">
            {{ badge.value ? '-' + badge.value + '%' : null }}
          </em>
        }
      </div>
    }
    <dl [ngClass]="{ 'out-of-stock': product.productStatus === PRODUCT_STATUS.OUT_OF_STOCK }" [class]="i18n.language">
      <ng-template #restockBtn>
        @if (isRestockAlertUiEnabled && shouldShowRestockButton()) {
          <button
            type="button"
            class="button-restock-alert"
            [class.is-subscribed]="isRestockSubscribed()"
            [attr.aria-label]="isRestockSubscribed() ? 'Restock Notification ON' : 'Restock Notification OFF'"
            (click)="subscribeRestockAlert($event)"
          >
            <svg
              class="button-restock-alert__icon"
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="currentColor"
              aria-hidden="true"
            >
              <path
                class="button-restock-alert__bell--off"
                d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-6V11c0-3.07-1.63-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.64 5.36 6 7.93 6 11v5l-2 2v1h16v-1l-2-2zm-2 1H8v-6c0-2.48 1.51-4.5 4-4.5s4 2.02 4 4.5v6z"
              />
              <path
                class="button-restock-alert__bell--on"
                d="M7.58 4.08L6.15 2.65C3.75 4.48 2.17 7.3 2.03 10.5h2c.15-2.65 1.51-4.97 3.55-6.42zm12.39 6.42h2c-.15-3.2-1.73-6.02-4.12-7.85l-1.42 1.43c2.02 1.45 3.39 3.77 3.54 6.42zM18 11c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2v-5zm-6 11c.14 0 .27-.01.4-.04.65-.14 1.18-.58 1.44-1.18.1-.24.15-.5.15-.78h-4c.01 1.1.9 2 2.01 2z"
              />
            </svg>
            <span class="button-restock-alert__label">{{ isRestockSubscribed() ? 'Restock Notification ON' : 'Restock Notification OFF' }}</span>
          </button>
        }
      </ng-template>
      @if (use) {
        <dt (click)="onSelectProduct(product)">
          <mat-checkbox
            class="checkbox"
            [checked]="isChecked"
            (change)="onSelectProduct(product)"
            (click)="onSelectProduct(product)"
          ></mat-checkbox>
          <img src="{{ product?.images?.[0]?.endpoint || '' }}" alt="product" draggable="false" />
          <ng-container *ngTemplateOutlet="restockBtn"></ng-container>

        </dt>
      }
      @if (!use) {
        <dt (click)="goToProductDetail()">
          <img src="{{ product?.images?.[0]?.endpoint || '' }}" alt="product" draggable="false" />
          <ng-container *ngTemplateOutlet="restockBtn"></ng-container>

        </dt>
      }
      <dd (click)="goToProductDetail()">
        @if (bestSeller) {
          <div [ngClass]="{ number: numberTag, active: numberTag && numberTag === '1' }">
            {{ numberTag }}
            @if (numberTag && numberTag === '1') {
              <img src="/assets/images/badge-crown.svg" alt="best-badge" draggable="false" />
            }
          </div>
        }
        <p class="brand">{{ product.brand.englishName }}</p>
        <p class="product-name">
          <span>
            {{ product.englishName }}
          </span>
        </p>
        @if (product?.mapperSaleProducts?.[0]?.productOption?.reviewDetails?.ratingAvg) {
          <div class="review-rating">
            <div style="align-items: center; z-index: 1">
              <ngx-stars
                [readonly]="true"
                [size]="1"
                [maxStars]="5"
                [initialStars]="product?.mapperSaleProducts?.[0]?.productOption?.reviewDetails?.ratingAvg"
                [color]="'#e04fa3'"
              >
              </ngx-stars>
              <!-- <span style="font-weight: bold; font-size: 20px">Rating is {{ ratingDisplay }} out of 5</span> -->
            </div>
            <div style="display: flex; align-items: center">
              <span class="rating-total">{{
                product?.mapperSaleProducts?.[0]?.productOption?.reviewDetails?.ratingAvg | number: '1.2-2'
              }}</span>
              <span class="review-count">
                ({{ product?.mapperSaleProducts?.[0]?.productOption?.reviewDetails?.reviewCount | number }})</span
              >
            </div>
          </div>
        }
        @if (!isRecommendProduct && !(product?.mapperSaleProducts)[0].productOption.finalSaleSupplyPrice) {
          @if ((product?.mapperSaleProducts)[0].productOption.isFixedMsrp) {
            <del
              >MSRP&nbsp;${{
                product.minFixedMsrpPriceUSD !== product.maxFixedMsrpPriceUSD
                  ? (product.minFixedMsrpPriceUSD | currency: 'USD' : '' : '0.2') + '~'
                  : (product.minFixedMsrpPriceUSD | currency: 'USD' : '' : '0.2')
              }}</del
            >
          }
          @if (!(product?.mapperSaleProducts)[0].productOption.isFixedMsrp) {
            <del
              >MSRP&nbsp;${{
                product.minMsrpPriceUSD !== product.maxMsrpPriceUSD
                  ? (product.minMsrpPriceUSD | currency: 'USD' : '' : '0.2') + '~'
                  : (product.minMsrpPriceUSD | currency: 'USD' : '' : '0.2')
              }}</del
            >
          }
          <div class="price-row">
            <p>
              ${{
                product.minMsrpPriceUSD !== product.maxMsrpPriceUSD
                  ? (product.minSalePriceUSD | currency: 'USD' : '' : '0.2') + '~'
                  : (product.maxSalePriceUSD | currency: 'USD' : '' : '0.2')
              }}
              <span>{{
                product.minSupplyRate !== product.maxSupplyRate
                  ? (product.minSupplyRate | salesRate) + '%~' + (product.maxSupplyRate | salesRate) + '%'
                  : (product.minSupplyRate | salesRate) + '%'
              }}</span>
            </p>
            @if (product.productStatus !== PRODUCT_STATUS.OUT_OF_STOCK) {
              <a class="button-cart" (click)="addToCartModal(); $event.stopPropagation()"></a>
            }
          </div>
        }
        @if (!isRecommendProduct && (product?.mapperSaleProducts)[0].productOption.finalSaleSupplyPrice) {
          @if ((product?.mapperSaleProducts)[0].productOption.isFixedMsrp) {
            <del
              >MSRP ${{
                product.minFixedMsrpPriceUSD !== product.maxFixedMsrpPriceUSD
                  ? (product.minFixedMsrpPriceUSD | currency: 'USD' : '' : '0.2') + '~'
                  : (product.minFixedMsrpPriceUSD | currency: 'USD' : '' : '0.2')
              }}</del
            >
          }
          @if (!(product?.mapperSaleProducts)[0].productOption.isFixedMsrp) {
            <del
              >MSRP ${{
                product.minMsrpPriceUSD !== product.maxMsrpPriceUSD
                  ? (product.minMsrpPriceUSD | currency: 'USD' : '' : '0.2') + '~'
                  : (product.minMsrpPriceUSD | currency: 'USD' : '' : '0.2')
              }}</del
            >
          }
          <del style="padding-left: 5px">
            ${{
              product.minSalePriceUSD !== product.maxSalePriceUSD
                ? (product.minSalePriceUSD | currency: 'USD' : '' : '0.2') + '~'
                : (product.minSalePriceUSD | currency: 'USD' : '' : '0.2')
            }}<span style="padding-left: 5px">
              <del style="color: #e04fa3 !important">
                {{
                  product.minSupplyRate !== product.maxSupplyRate
                    ? (product.minSupplyRate | salesRate) + '%~' + (product.maxSupplyRate | salesRate) + '%'
                    : (product.minSupplyRate | salesRate) + '%'
                }}
              </del>
            </span>
          </del>
          <div class="price-row">
            <p>
              ${{
                product.minFinalSaleSupplyPriceUSD !== product.maxFinalSaleSupplyPriceUSD
                  ? (product.minFinalSaleSupplyPriceUSD | currency: 'USD' : '' : '0.2') + '~'
                  : (product.maxFinalSaleSupplyPriceUSD | currency: 'USD' : '' : '0.2')
              }}<span>{{
                product.minFinalSaleSupplyRate !== product.maxFinalSaleSupplyRate
                  ? (product.minFinalSaleSupplyRate | salesRate) +
                    '%~' +
                    (product.maxFinalSaleSupplyRate | salesRate) +
                    '%'
                  : (product.minFinalSaleSupplyRate | salesRate) + '%'
              }}</span>
            </p>
            @if (product.productStatus !== PRODUCT_STATUS.OUT_OF_STOCK) {
              <a class="button-cart" (click)="addToCartModal(); $event.stopPropagation()"></a>
            }
          </div>
        }
        @if (!isRecommendProduct) {
          <app-product-stock-badges [product]="product" />
        }
        @if (isRecommendProduct) {
          <p>
            {{ 'USD ' + ((product.maxSalePriceUSD * product.minMinMoq).toFixed(2) | currency: 'USD' : '' : '0.2') }}
          </p>
          <span>
            {{
              'USD ' + (product.maxSalePriceUSD | currency: 'USD' : '' : '0.2') + ' * ' + product.minMinMoq + ' unit'
            }}
          </span>
        }

        <!-- <div class="badge" *ngIf="hasBadge">
              <ng-container *ngFor="let badge of product | badges: 'badge':excludeBadges">
                <span [class]="badge.badgeType">{{ badge.badgeType | commonCode: 'BADGE_TYPE' }}</span>
              </ng-container>
            </div> -->
      </dd>
    </dl>
  </a>
  @if (product.productStatus !== PRODUCT_STATUS.OUT_OF_STOCK && isRecommendProduct) {
    <a (click)="addToCartModal()" class="is-recommend-button">{{ 'BUTTON.ADD_TO_CART_EN' | t }}</a>
  }
</div>
